var baseUrl = 'https://docs.sanity.io/help/'

module.exports = function generateHelpUrl(slug) {
  return baseUrl + slug
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sanity/block-content-to-hyperscript/node_modules/@sanity/generate-help-url/index.js
// module id = 192
// module chunks = 0